import React from 'react';
import {Page} from '@adobe/aem-react-editable-components';

// This component is the application entry point

const App = (props) => {
  return (
    <div className="aem-react-app">
      <Page {...props} />
    </div>
  );
};

export default App;
